import { styled, keyframes } from "styled-components";

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const Spinner = styled.div`
  animation: ${rotate360} 1s linear infinite;
  border-top: 2px solid ${({ theme }) => theme.colors.primary};
  border-right: 2px solid transparent;
  border-bottom: 2px solid ${({ theme }) => theme.colors.primary};
  border-left: 2px solid ${({ theme }) => theme.colors.primary};
  background: transparent;
  width: 82px;
  height: 82px;
  border-radius: 50%;
  position: relative;
  transition: 1s ease border-color;
  transform: translateZ(10);
`

export default function SpinningLoader() {
  return (
    <Spinner />
  )
}
